
      import API from "!../../../../../../../../Users/xwxgs/Desktop/meishubao/llm/scratch-editor/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../../../../../Users/xwxgs/Desktop/meishubao/llm/scratch-editor/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../../../../../Users/xwxgs/Desktop/meishubao/llm/scratch-editor/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../../../../../Users/xwxgs/Desktop/meishubao/llm/scratch-editor/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../../../../../Users/xwxgs/Desktop/meishubao/llm/scratch-editor/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../../../../../Users/xwxgs/Desktop/meishubao/llm/scratch-editor/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../../../../../Users/xwxgs/Desktop/meishubao/llm/scratch-editor/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[7].use[1]!../../../../../../../../Users/xwxgs/Desktop/meishubao/llm/scratch-editor/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[7].use[2]!./custom-procedures.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;
options.insert = insertFn.bind(null, "head");
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../../../../../Users/xwxgs/Desktop/meishubao/llm/scratch-editor/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[7].use[1]!../../../../../../../../Users/xwxgs/Desktop/meishubao/llm/scratch-editor/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[7].use[2]!./custom-procedures.css";
       export default content && content.locals ? content.locals : undefined;
